enum IndicadorOperacao {
    Normal = 0,
    ConsumidorFinal = 1,
}

export default IndicadorOperacao;
